import { render, staticRenderFns } from "./AppStart.vue?vue&type=template&id=4338c505&scoped=true&"
import script from "./AppStart.vue?vue&type=script&lang=js&"
export * from "./AppStart.vue?vue&type=script&lang=js&"
import style0 from "./AppStart.vue?vue&type=style&index=0&id=4338c505&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4338c505",
  null
  
)

export default component.exports